<router-outlet>
  @if (searchLoading$()) {
    <mat-spinner class="loader-app"></mat-spinner>
    <div class="overlay-container"></div>
  }
</router-outlet>
